import { Link } from 'react-router-dom';
import Logo from './Logo';

interface SiteNavProps {
  /** 'landing' shows the full marketing nav; 'minimal' just the logo + back link. */
  variant?: 'landing' | 'minimal';
}

export default function SiteNav({ variant = 'landing' }: SiteNavProps) {
  return (
    <header className="nav">
      <div className="container nav__inner">
        <Link to="/" className="nav__logo" aria-label="reeve home">
          <Logo height={30} />
        </Link>

        {variant === 'landing' ? (
          <>
            <nav className="nav__pills" aria-label="Primary">
              <a className="nav__pill" href="#how-it-works">
                How it works
              </a>
              <a className="nav__pill" href="#pricing">
                Pricing
              </a>
              <a className="nav__pill" href="#trust">
                Trust
              </a>
            </nav>
            <div className="nav__actions">
              <Link to="/waitlist" className="nav__login">
                Log in
              </Link>
              <Link to="/waitlist" className="nav__cta">
                Start for free
              </Link>
            </div>
          </>
        ) : (
          <Link to="/" className="nav__login">
            ← Back to home
          </Link>
        )}
      </div>
    </header>
  );
}
